import React from "react";

import theme from "@/foundation/Theme";

import {
  CTAButton,
  SecondaryCTAButton,
  Description,
  FixedSection,
  Heading,
  Icon,
  LHSSection,
  RHSSection,
  WrapContainer,
  Subtitle,
  ButtonDescription,
} from "./style";

function FloatingBanner({
  width,
  data = {},
  fixedRef,
  handleScrollToSection = () => {},
  userData,
}) {
  const meta = data?.floating_banner?.meta
    ? JSON.parse(data?.floating_banner?.meta)
    : {};

  const callbackCTA = (
    <CTAButton
      variant="primary1"
      onClick={handleScrollToSection}
      bgColor={
        width <= 1023 ? theme.colors.white : theme.colorsV2.shyft.purple_text
      }
      hoverColor={
        width <= 1023 ? theme.colors.white : theme.colorsV2.shyft.purple_text
      }
      TextColor={
        width >= 1024 ? theme.colors.white : theme.colorsV2.primary.shade_800
      }
    >
      <Icon
        icon="icon-phone-3"
        fill={
          width >= 1024 ? theme.colors.white : theme.colorsV2.primary.shade_800
        }
      />
      {data?.floating_banner?.cta_title || "Request a Call Back"}
    </CTAButton>
  );

  const purchasePackCTA = (
    <SecondaryCTAButton
      variant="primary1"
      onClick={() => (window.location.href = meta?.purchase_pack_cta_action)}
      bgColor={
        width <= 1023 ? theme.colors.white : theme.colorsV2.shyft.purple_text
      }
      hoverColor={
        width <= 1023 ? theme.colors.white : theme.colorsV2.shyft.purple_text
      }
      TextColor={
        width >= 1024 ? theme.colors.white : theme.colorsV2.primary.shade_800
      }
    >
      <Icon
        icon="icon-credit-card"
        fill={
          width >= 1024 ? theme.colors.white : theme.colorsV2.primary.shade_800
        }
      />
      {meta?.purchase_pack_cta_title}
    </SecondaryCTAButton>
  );

  const bookTrialCTA = (
    <SecondaryCTAButton
      variant="primary1"
      onClick={() => (window.location.href = meta?.book_trial_cta_action)}
      bgColor={
        width <= 1023 ? theme.colors.white : theme.colorsV2.shyft.purple_text
      }
      hoverColor={
        width <= 1023 ? theme.colors.white : theme.colorsV2.shyft.purple_text
      }
      TextColor={
        width >= 1024 ? theme.colors.white : theme.colorsV2.primary.shade_800
      }
    >
      <Icon
        icon="icon-credit-card"
        fill={
          width >= 1024 ? theme.colors.white : theme.colorsV2.primary.shade_800
        }
      />
      {meta?.book_trial_cta_title}
    </SecondaryCTAButton>
  );

  return (
    <FixedSection ref={fixedRef}>
      <WrapContainer py={"16px"} alignItems={"center"}>
        <LHSSection flexDirection={"column"}>
          <Heading variant="heading5">{data?.floating_banner?.title}</Heading>
          {width >= 1024 && (
            <Description variant="heading6">
              {data?.floating_banner?.description}
            </Description>
          )}
          {meta?.button_description && (
            <ButtonDescription
              variant="paragraph2"
              isExtraBold
              color={
                width >= 1024
                  ? meta?.button_description_color ||
                    theme.colorsV2.gray.shade_900
                  : meta?.button_description_color_mobile || theme.colors.white
              }
            >
              {meta?.button_description}
            </ButtonDescription>
          )}
        </LHSSection>
        <RHSSection>
          {!userData && width >= 1024 && data?.floating_banner?.subtitle && (
            <Subtitle variant="label3" px={"8px"}>
              {data?.floating_banner?.subtitle}
            </Subtitle>
          )}
          {userData && purchasePackCTA}
          {userData && bookTrialCTA}
          {callbackCTA}
        </RHSSection>
      </WrapContainer>
    </FixedSection>
  );
}

export default FloatingBanner;
